// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 3H1V5.82911L11.9995 11.3798L23 5.82864V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 8.06887L11.9995 13.62L1 8.06934V21L23 21V8.06887Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mail-filled')
export default class MailFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mail-filled',
    }
  }
}
